<app-table
    class="hidden md:block"
    [loading]="loading()"
    [pageSize]="activeState().pageSize()"
    [currentPage]="activeState().page()"
    [totalItems]="total()"
    (pageChange)="activeState().page.set($event)"
    (pageSizeChange)="activeState().pageSize.set($event)"
>
    <app-table-head>
        @if (selectionMode()) {
            <app-table-header width="20px"></app-table-header>
        }
        <app-table-header width="90px"></app-table-header>
        <app-table-header
            width="400px"
            [filterable]="true"
            (sortOrderChanged)="sortChange.emit({ column: 'subject', order: $event })"
            >{{ 'request-tables.subject' | translate }}</app-table-header
        >
        <app-table-header width="180px">{{ 'request-tables.requestor-email' | translate }}</app-table-header>
        <app-table-header width="180px">{{ 'request-tables.created' | translate }}</app-table-header>
        <app-table-header
            width="180px"
            [filterable]="true"
            (sortOrderChanged)="sortChange.emit({ column: 'updated_at', order: $event })"
            >{{ 'request-tables.updated' | translate }}</app-table-header
        >
        <app-table-header width="180px">{{ 'request-tables.status' | translate }}</app-table-header>
    </app-table-head>
    @for (request of tasks(); track $index) {
        <app-table-row (click)="openRequest(request)" [pillColor]="statusPillColorMap[request.status]">
            @if (selectionMode()) {
                <app-table-cell width="20px">
                    @if (request.status === 'saved') {
                        <sh-checkbox
                            [attr.active]="selectedIds().has(request.id) ? true : null"
                            (click)="$event.stopPropagation()"
                            (checked)="toggleRow(request, !selectedIds().has(request.id))"
                        ></sh-checkbox>
                    } @else {
                        <span
                            class="cursor-not-allowed pointer-events-none"
                            [id]="'disabled-cb-desktop-' + $index"
                            (click)="$event.stopPropagation()"
                        >
                            <sh-checkbox [attr.disabled]="true"></sh-checkbox>
                        </span>
                        <sh-tooltip
                            [target]="'disabled-cb-desktop-' + $index"
                            [label]="'common.table.not-saved-requests-tooltip' | translate"
                            placement="top"
                            variation="short"
                        ></sh-tooltip>
                    }
                </app-table-cell>
            }
            <app-table-cell width="90px">IRO-{{ request.displayId }}</app-table-cell>
            <app-table-cell width="400px">{{ request.subject }}</app-table-cell>
            <app-table-cell width="180px">{{ request.email }}</app-table-cell>
            <app-table-cell width="180px">
                <app-table-date-cell [date]="request.createdAt"></app-table-date-cell>
            </app-table-cell>
            <app-table-cell width="180px">
                <app-table-date-cell [date]="request.updatedAt"></app-table-date-cell>
            </app-table-cell>
            <app-table-cell width="180px">
                <app-requests-status-pill [status]="request.status"></app-requests-status-pill>
            </app-table-cell>
        </app-table-row>
    }
</app-table>

<app-mobile-table
    class="md:hidden"
    [loading]="loading()"
    [totalItems]="total()"
    [pageSize]="activeState().pageSize()"
    [currentPage]="activeState().page()"
    (pageChange)="activeState().page.set($event)"
    (pageSizeChange)="activeState().pageSize.set($event)"
>
    @for (request of tasks(); track $index) {
        <app-mobile-table-card (click)="openRequest(request)" [accentColor]="statusPillColorMap[request.status]">
            <div class="flex items-center gap-2">
                @if (selectionMode()) {
                    @if (request.status === 'saved') {
                        <sh-checkbox
                            [attr.active]="selectedIds().has(request.id) ? true : null"
                            (click)="$event.stopPropagation()"
                            (checked)="toggleRow(request, !selectedIds().has(request.id))"
                        ></sh-checkbox>
                    } @else {
                        <span
                            class="cursor-not-allowed pointer-events-none"
                            [id]="'disabled-cb-mobile-' + $index"
                            (click)="$event.stopPropagation()"
                        >
                            <sh-checkbox [attr.disabled]="true"></sh-checkbox>
                        </span>
                        <sh-tooltip
                            [target]="'disabled-cb-mobile-' + $index"
                            [label]="'common.table.not-saved-requests-tooltip' | translate"
                            placement="top"
                            variation="short"
                        ></sh-tooltip>
                    }
                }
                <span class="text-base text-shui-text-strong flex items-center font-semibold text-wrap"
                    >IRO-{{ request.displayId }}: {{ request.subject }}</span
                >
            </div>
            <div class="flex flex-col gap-4">
                <app-mobile-row-field label="request-tables.requestor-email">
                    {{ request.email }}
                </app-mobile-row-field>
                <app-mobile-row-field label="request-tables.created">
                    <app-table-date-cell [date]="request.createdAt"></app-table-date-cell>
                </app-mobile-row-field>
                <app-mobile-row-field label="request-tables.updated">
                    <app-table-date-cell [date]="request.updatedAt"></app-table-date-cell>
                </app-mobile-row-field>
            </div>
        </app-mobile-table-card>
    }
</app-mobile-table>
